module.exports = __webpack_public_path__ + "faq/img/problem2.d8cfd4e8.png";